<template>
  <div class="declaration-modal">
    <el-button
      type="primary"
      @click="dialogVisible = true">
      {{ $t('declaration.addProperty') }}
    </el-button>
    <el-dialog
      :title="modalTitle"
      :visible.sync="dialogVisible"
      class="center-with-menu"
      custom-class="declaration-modal__dialog">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="120px"
        class="declaration-modal__dialog__inputs"
        @submit.native.prevent="saveProperty">
        <el-form-item :label="$t('declaration.modal.date.name')" prop="date">
          <el-date-picker
            v-model="form.date"
            type="date"
            format="dd/MM/yyyy"
            :picker-options="{ disabledDate }"
            class="declaration-modal__dialog__inputs--size"
            :placeholder="$t('declaration.modal.date.name')" />
        </el-form-item>
        <el-form-item :label="$t('declaration.modal.name.name')" prop="name">
          <el-input
            v-model="form.name"
            class="declaration-modal__dialog__inputs--size"
            :placeholder="$t('declaration.modal.name.name')" />
        </el-form-item>
        <el-form-item :label="$t('declaration.modal.quantity.name')" prop="quantity">
          <el-input
            v-model.number="form.quantity"
            type="number"
            class="declaration-modal__dialog__inputs--size"
            :placeholder="$t('declaration.modal.quantity.name')" />
        </el-form-item>
        <el-form-item :label="$t('declaration.modal.price.name')" prop="price">
          <el-input
            v-model.number="form.price"
            type="number"
            class="declaration-modal__dialog__inputs--size"
            :placeholder="$t('declaration.modal.price.name')" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="cancel">{{ $t('base.cancel') }}</el-button>
        <el-button type="primary" @click="saveProperty">{{ modalTitle }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'declarationInputs',
  props: {
    propertyEdited: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const dateValidator = (rule, value, callback) => {
      const date = new Date(value);
      if (date instanceof Date && !Number.isNaN(date)) {
        return callback();
      }
      return callback(new Error(this.$t('declaration.modal.date.warning')));
    };
    const qualityValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('declaration.modal.quantity.warning')));
      }
      if (!Number.isInteger(value) || value < 1) {
        return callback(new Error(this.$t('declaration.modal.quantity.warning')));
      }
      return callback();
    };
    const priceValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('declaration.modal.price.warning')));
      }
      if (!Number.isNaN(value - parseFloat(value)) && value < 0) {
        return callback(new Error(this.$t('declaration.modal.price.warning')));
      }
      return callback();
    };
    return {
      editMod: false,
      dialogVisible: false,
      form: {
        date: null,
        name: null,
        price: null,
        quantity: 1,
      },
      rules: {
        date: [
          {
            validator: dateValidator,
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: this.$t('declaration.modal.name.warning'),
            trigger: 'blur',
          },
        ],
        quantity: [
          {
            validator: qualityValidator,
            trigger: 'blur',
          },
        ],
        price: [
          {
            validator: priceValidator,
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    modalTitle() {
      return this.$t(this.editMod
        ? 'declaration.modal.titleEdit'
        : 'declaration.modal.titleAdd');
    },
  },
  methods: {
    disabledDate(date) {
      return (new Date(date)).getTime() >= Date.now();
    },
    saveProperty() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.editMod) {
            this.propertyEdited.date = this.form.date;
            this.propertyEdited.name = this.form.name;
            this.propertyEdited.price = this.form.price;
            this.$emit('edited-property', { ...this.form });
            this.editMod = false;
          } else {
            this.$emit('add-property', { ...this.form });
          }
          this.$refs.form.resetFields();
          this.dialogVisible = false;
        }
      });
    },
    cancel() {
      this.editMod = false;
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
  },
  created() {

  },
  watch: {
    propertyEdited(newVal) {
      if (Object.keys(newVal).length) {
        this.editMod = Object.keys(newVal).length;
        this.form = { ...newVal };
        this.dialogVisible = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.declaration-modal {
  display: inline-block;
  margin-right: 20px;
}

:deep(.declaration-modal) {
  &__dialog {
    width: 90%;
    @include breakpoint(tablet) {
      width: 75%;
    }
    &__inputs {
      &--size {
        max-width: 210px;
        width: 100%;
      }
    }
  }
}

</style>
